import { SortOrder } from 'src/app/core/interface/sort-order';
import { Page } from "src/app/core/models/page";

export class AutoPrintSettingGetDetailRequest {
  facility: string | null;
  deliveryTypes: string[] | null;
  docTypes: string[] | null;
  orgIds: string[] | null;
  consigneeKeys: string[] | null;
  forwarderCodes: string[] | null;

  constructor() {
    this.facility = null;
    this.deliveryTypes = null;
    this.docTypes = null;
    this.orgIds = null;
    this.consigneeKeys = null;
    this.forwarderCodes = null;
  }
}
